import { STYLE_HAS_ART } from '@/config/uiStyle';
import { useUiStyle } from '@/contexts/UiStyleContext';

/**
 * The background art gate (spec docs/specs/2026-10-08-v2-theme-styles-design.md §5). Styles with
 * art (Cosmos, Arcade) draw the admin background: the theme gradient and overlay of the layout
 * shells, the uploaded image (BackgroundLayer), the particles (VFXCanvas) and the decorative
 * objects. The others (Daylight, Luxe) paint the style's --k-page-background instead. Follows a
 * live style switch (preview builds). Components never branch on the style name: this flag is
 * the only style-aware check outside the boot, the font loader and the dev switcher.
 */
export function useStyleHasArt(): boolean {
  return STYLE_HAS_ART[useUiStyle().style];
}
